import type { Theme } from "../types/Theme";
import * as Mixins from "./Mixins";
import { shouldUseModernTheme } from "./navigationButtonThemeColors";

/** Modern page-message chrome only when {@link Theme.UseModernTheme} is strictly true. */
export function useModernPageMessageStyles(theme: Theme): boolean {
    return shouldUseModernTheme(theme);
}

/** Legacy keeps hardcoded #707070; modern uses ControlBorderColor. */
export function resolvePageMessageBorder(theme: Theme): string {
    if (!useModernPageMessageStyles(theme)) {
        // Missing `px` is intentional: invalid CSS means legacy page messages never render this border (matches 7.04 PageRenderer.styles.ts).
        return `${theme.BorderWidth} solid #707070`;
    }
    const width = theme.BorderWidth ?? 1;
    return `${width}px solid ${theme.ControlBorderColor}`;
}

export function resolvePageMessageFontSize(theme: Theme): string {
    if (!useModernPageMessageStyles(theme)) {
        return "1.1em";
    }
    return Mixins.getFontSize(theme.TextFontSize, `${theme.BaseFontSize ?? 16}px`);
}

export function resolvePageMessageColor(theme: Theme): string | undefined {
    if (!useModernPageMessageStyles(theme)) {
        return undefined;
    }
    return Mixins.foregroundColor(theme, Mixins.wrapperBackgroundColor(theme));
}
